import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import BalanceSheet from "./BalanceSheet";
import { FaChartLine, FaArrowLeft } from "react-icons/fa";
import { usePermissions } from "../../context/PermissionContext";
import AccessDenied from "../ui/AccessDenied";

const BalanceSheetPage = () => {
  const navigate = useNavigate();
  const { canView } = usePermissions();

  if (!canView("balance_sheet")) {
    return <AccessDenied moduleName="Balance Sheet" action="view" />;
  }

  const [data, setData] = useState(null);

  useEffect(() => {
    fetch("/api/financials/balance-sheet")
      .then((res) => res.json())
      .then((res) => setData(res))
      .catch((err) => console.error(err));
  }, []);

  return (
    <div className="container-fluid">
      <div className="d-flex justify-content-end align-items-center gap-2 mt-3 mb-3">
        <button
          className="btn btn-primary btn-sm d-flex align-items-center gap-1 shadow-sm"
          onClick={() => navigate("/dashboard/reports/balance-sheet-comparison")}
        >
          <FaChartLine /> 5-Year Comparison
        </button>
        <button className="btn btn-secondary btn-sm d-flex align-items-center gap-1" onClick={() => navigate("/dashboard")}>
          <FaArrowLeft /> Back to Dashboard
        </button>
      </div>
      <BalanceSheet data={data} />
    </div>
  );
};

export default BalanceSheetPage;
